var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters['popups/showManualPopup'])?_c('Modal20Percent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }